var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "el-row",
          { staticClass: "action-btn-row" },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.SaveCategory,
                    expression: "SaveCategory",
                  },
                ],
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.addRow },
              },
              [_vm._v(_vm._s(_vm.$t("common.addNew")))]
            ),
          ],
          1
        ),
        _c(
          "el-table",
          {
            ref: "tableData",
            staticClass: "table",
            attrs: {
              "max-height": "435",
              data: _vm.tableData,
              border: "",
              "highlight-current-row": "",
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "bigName",
                label: _vm.$t("spm.bigName"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.showOperator
                        ? _c("el-input", {
                            attrs: { maxlength: "100" },
                            model: {
                              value: scope.row.bigName,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "bigName", $$v)
                              },
                              expression: "scope.row.bigName",
                            },
                          })
                        : _c("span", [_vm._v(_vm._s(scope.row.bigName))]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "score",
                label: _vm.$t("spm.specUpload"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.showOperator && scope.row.type === "add"
                        ? _c("el-input", {
                            attrs: { type: "number" },
                            model: {
                              value: scope.row.score,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "score", $$v)
                              },
                              expression: "scope.row.score",
                            },
                          })
                        : _c("span", [_vm._v(_vm._s(scope.row.score))]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "statusI18n",
                label: _vm.$t("common.operation"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.SaveCategory,
                              expression: "SaveCategory",
                            },
                          ],
                          staticClass: "btn",
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.edit(scope.row)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.edit")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.SaveCategory,
                              expression: "SaveCategory",
                            },
                          ],
                          staticClass: "btn",
                          attrs: { size: "mini", type: "danger" },
                          on: {
                            click: function ($event) {
                              return _vm.deleteRow(scope.row, scope.$index)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.del")) + " ")]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "acl",
                rawName: "v-acl",
                value: _vm.SaveCategory,
                expression: "SaveCategory",
              },
            ],
            staticStyle: { "padding-top": "15px", "text-align": "center" },
          },
          [
            _c(
              "el-button",
              {
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.saveOrUpdate },
              },
              [_vm._v(_vm._s(_vm.$t("common.saveDraft")))]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }